<div class="feature-container">
    <div class="feature-content container">
        <div class="feature-header">
            <div class="left-section">
                <p class="feature-title font-poppins" appEllipsis  maxWidth="100%">Featured Block Collection</p>
                <p class="feature-subtitle" appEllipsis  maxWidth="100%">Discover our most colorful and creative building sets</p>
            </div>

            <a routerLink="/products" [queryParams]="{ category: 'featured' }" class="right-section">
                <p class="view-all">View All</p>
                <mat-icon [svgIcon]="'rightarrow'" class="right-arow-icon"></mat-icon>
            </a>
        </div>
        <div class="feature-products">
            @for (product of featuredProducts; let i = $index; track i) {
            <app-product-card
                [product]="product"
                class="card"
                [imageBgClass]="'product-image-gradient' + ((i % 3) + 1)"
                (isNavbarOpen)="setNavbarOpen($event)"
            ></app-product-card>
            }
        </div>
    </div>
    <div class="right-navbar" *ngIf="isNavbarOpen">
        <app-right-navbar (closeEvent)="onCloseNavbar()"></app-right-navbar>
    </div>
</div>
